// extracted by mini-css-extract-plugin
export default {"subscribe":"Subscribe_subscribe__lRgQ8","title":"Subscribe_title__3O2wU"};